// extracted by mini-css-extract-plugin
export default {"list":"SnapshotList_list__GOhW+","header":"SnapshotList_header__VW4Wl","selected":"SnapshotList_selected__pdp-a","wrapped":"SnapshotList_wrapped__y6bad"};